/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для избранного
   */
  app.WishListView = app.ItemsView.extend({
    
    itemEl: 'tr[id]'
    
  });
  
})();

}.call(window));